import { render, staticRenderFns } from "./slSet.vue?vue&type=template&id=b2d4b2a6&scoped=true&"
import script from "./slSet.vue?vue&type=script&lang=js&"
export * from "./slSet.vue?vue&type=script&lang=js&"
import style0 from "./slSet.vue?vue&type=style&index=0&id=b2d4b2a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d4b2a6",
  null
  
)

export default component.exports